/*
The promocode component manages the applied discount code and fetching updates to the discounts endpoint.
 */

import Component from "./../../component";
import {readCookie} from "./../../helpers/cookies"

export const CartDrawerPromocodeConfig = {
    signature: 'CartDrawerPromocode',
    baseHtmlClass: 'go-cart__drawer__promocode',
    selector: '.go-cart__drawer__promocode',

    initedHtmlClassModifier: 'inited',
    hasPromocodeHtmlClassModifier: 'has_promocode',

    headerElementSelector: '.cart__drawer__promocode__header',
    bodyElementSelector: '.cart__drawer__promocode__body',

    promocodeInputSelector: '.cart__drawer__promocode__fields__code input',
    commitButtonSelector: '.cart__drawer__promocode__fields__buttons button',
    resetButtonSelector: '',

    cookieKey: 'discount_code',
};

export class CartDrawerPromocode extends Component {

    constructor(id_or_element, goCart) {
        super({
            element: id_or_element,
            config: CartDrawerPromocodeConfig
        });

        this.goCart = goCart;

        this.headerElement = this.element.querySelector(CartDrawerPromocodeConfig.headerElementSelector);
        this.bodyElement = this.element.querySelector(CartDrawerPromocodeConfig.bodyElementSelector);

        this.promocode = readCookie(CartDrawerPromocodeConfig.cookieKey);

        this.promocodeInput = this.element.querySelector(CartDrawerPromocodeConfig.promocodeInputSelector);
        if (this.promocodeInput) {
            this.promocodeInput.value = this.promocode;
            this.promocodeInput.addEventListener('change', this.handlePromocodeInputChange.bind(this))
        }

        this.inited = true;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, CartDrawerPromocodeConfig.initedHtmlClassModifier);
        this.renderCartDrawerSummaryComponent();
    }

    renderCartDrawerSummaryComponent() {
        if (!this.goCart || !this.goCart.cartDrawerSummaryComponent) return;
        this.goCart.cartDrawerSummaryComponent.render();
    }

    handlePromocodeInputChange(event) {
        this.promocode = this.hasPromocodeInputValue() ? this.getPromocodeInputValue() : '';
        this.render();
        this.updateDiscount().then(() => this.render()).catch(()=>{

        });
    }

    updateDiscount() {
        return window.fetch(`/discount/${this.promocode}`);
    }

    getPromocodeInputValue() {
        if (!this.promocodeInput) return null;
        return this.promocodeInput.value;
    }

    hasPromocodeInputValue() {
        const value = this.getPromocodeInputValue();
        return (typeof value !== 'undefined') && (value !== null) && (value !== '');
    }

    hasPromocode() {
        return (this.promocode !== null && this.promocode !== '');
    }

}
